module.exports = __webpack_public_path__ + "img/01.3b046863.png";